import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, HostListener } from "@angular/core";
import { ServiceModelManagerServices } from "../../services/service-model-manager.services";
import { PaginatorServices } from "../../services/paginator.services";
import { MongoImageServices } from "../../services/mongoImage.services";
import { MongoVideoServices } from "../../services/mongoVideo.services";

@Component({
    selector: 'paginator',
    template: require('./paginator.component.pug'),
    styles: [require('./paginator.component.scss')]
})

export class PaginatorComponent implements OnInit, OnDestroy, OnChanges {
    private service: string;
    private modelSubscription: any;
    private paginationSubscription: any;
    private pagination: any = { page: undefined, pages: undefined };

    constructor(
      private model : ServiceModelManagerServices,
      private images: MongoImageServices,
      private videos: MongoVideoServices,
    ) {}

    ngOnInit(): void {
      this.modelSubscription = this.model.serviceReady.subscribe( (serviceUpdate: any) => {
        this.service = serviceUpdate;
      })

      this.paginationSubscription = this[this.service].onUpdatedPagination.subscribe( (updatedPagination: any) => {
        if ( updatedPagination ) this.pagination = updatedPagination;
      })

    }

    ngOnChanges( change: any ) : void {}

    ngOnDestroy(): void {
      this.cursor = undefined;
    }

    @Input() cursor: any;

    @Output() turn: any = new EventEmitter();

    goToPage( direction: string ): void {
      const increment = ( direction === 'forward' );
      if ( this.cursor ) {
        let { page, pages } = this.cursor;
        if (increment ) {
          if ( page === pages ) this.pagination.page = 1;
          else this.pagination.page ++;
        }
        else {
          if ( page === 1 ) this.pagination.page = pages;
          else this.pagination.page --;
        }
      }

      this.turn.emit({ page: this.pagination.page });

    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/paginator/paginator.component.ts